import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute,NavigationEnd} from '@angular/router';
import {NavigationEvent} from "../common/NavigationEvent";
import {NavigationService} from "../common/NavigationEventService";
import {ToolbarService} from "../common/ToolbarEventService";
import {PaginationService} from "../common/PaginationService";
import {PaginationEvent} from "../common/PaginationEvent";
import { Subscription } from 'rxjs';
import {ToolbarEvent} from "../common/ToolbarEvent";
import {ToolbarEventPageEnum} from "../common/ToolbarEvent";
import {TranslateService} from "@ngx-translate/core";
import {Authorization} from "../authorization/authorization.component";
import {interval} from "rxjs";
import {NotificationService} from "../common/NotificationService";
import {BulkOperationsService} from "../common/BulkOperationsService";
import {BulkOperationsEvent} from "../common/BulkOperationsEvent";


declare var $: any;
declare var FixedNavbar: any;
/**
 * This class represents the navigation bar component.
 */
@Component({
    selector: 'sd-navbar',
    templateUrl: 'navbar.component.html',
    styleUrls: ['navbar.component.css'],
    providers: [],
    standalone: false
})

export class NavbarComponent implements OnInit, AfterViewInit, OnDestroy{

  navigationContent: string = "none";
  toolbarSubscription: Subscription;
  paginationSubscription:Subscription;
  bulkOperationSubscription:Subscription;
  isBulkOperationActive:boolean=false;
  timerSubscription:Subscription;
  private routerEventSubscription: any;
  private routerParamSubscription: any;
  currentToolbar:ToolbarEvent = new ToolbarEvent(ToolbarEventPageEnum.NONE, "", null, "", "","", "", "", "");
  currentPagination:PaginationEvent = new PaginationEvent("", true, true, false, "",false, "");
  showNavbar: boolean = false;
  isAfixInitialized: boolean = false;

  //Pagination setting
  listInterval:string="";
  isPreButtonActive:boolean = true;
  isNextButtonActive:boolean = true;
  innerHtmlStatus:string = "Select Status";
  innerHtmlSorting:string = "Creation Date";
  innerHtmlBulkOperations:string="Bulk Operations";
  isSmartStatusSelected:boolean = false; //if (innerHtmlSorting == updated)
  lastSearchKey:string="";
  selfSign:string="";
  isAccountSuspended:boolean=false;
  isReachedMaxSignLimit:boolean=false;
  requestSign:string="";
  isSubscriptionInitialized:boolean=false;
  isMenuInitialized: boolean = false;
  subscription:any;
  page:string="";
  selectedNavbarItem="";
  jobJocation:string="";
  jobLocationAction:string="";
  isRequestCodeUsed:boolean=false;
  isSuitToCombine:boolean = false;
  isSuitToCreateTemplate:boolean = false;
  selectedItem:string="";
  canCreatePublicLink:boolean = false;
  isPlanQuotaSuitToUpload:boolean = false;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private location: Location,
              private navigationService: NavigationService,
              private toolbarService: ToolbarService,
              private bulkOperationsService: BulkOperationsService,
              private paginationService :PaginationService,
              private notificationService: NotificationService,
              private translate: TranslateService,
              private authorization: Authorization
  ) {
    console.log(this.location.path());
    this.navigationService.value = "3";
    this.bulkOperationTitle(this.innerHtmlBulkOperations);
  }

  ngOnInit() {

    let _thisOnInit = this;

    this.toolbarSubscription = this.toolbarService.eventOccured$.subscribe(
      (event: ToolbarEvent) => this.onToolbarEvent(event) //get the page info
    );

    this.paginationSubscription = this.paginationService.eventOccured$.subscribe(
      (pageEvent: PaginationEvent) => this.onPaginationEvent(pageEvent) //get the page info
    );

    this.bulkOperationSubscription = this.bulkOperationsService.eventOccured$.subscribe(
      (bulkOperationEvent: BulkOperationsEvent) => this.onBulkOperationEvent(bulkOperationEvent)
    );

    this.routerEventSubscription = this.router.events.subscribe(function (routerEvent) {
      if (routerEvent instanceof NavigationEnd) {
        if (routerEvent.urlAfterRedirects.startsWith("/docs")) {
          _thisOnInit.navigationContent = "docs";
          _thisOnInit.displayNavbar();
          _thisOnInit.selectedNavbarItem = "navbar-second-toggle-docs"
        }
        else if (routerEvent.urlAfterRedirects.startsWith("/doc-request")) {
          _thisOnInit.navigationContent = "doc-request";
          _thisOnInit.hideNavbar();
          //_thisOnInit.selectedNavbarItem = "navbar-second-toggle-doc-request"
        }
        else if (routerEvent.urlAfterRedirects.startsWith("/doc")) {
          _thisOnInit.navigationContent = "doc";
          _thisOnInit.displayNavbar();
          _thisOnInit.selectedNavbarItem = "navbar-second-toggle-doc"
        }
        else if (routerEvent.urlAfterRedirects.startsWith("/combine")) {
          _thisOnInit.navigationContent = "combine";
          _thisOnInit.displayNavbar();
          _thisOnInit.selectedNavbarItem = "navbar-second-toggle-combine"
        }
        else if (routerEvent.urlAfterRedirects.startsWith("/signc")) {
          _thisOnInit.navigationContent = "signcades";
          _thisOnInit.displayNavbar();
          _thisOnInit.selectedNavbarItem = "navbar-second-toggle-sign"
        }
        else if (routerEvent.urlAfterRedirects.startsWith("/sign")) {
          _thisOnInit.navigationContent = "sign";
          _thisOnInit.displayNavbar();
          _thisOnInit.selectedNavbarItem = "navbar-second-toggle-sign"
        }
        else if (routerEvent.urlAfterRedirects.startsWith("/view")) {
          _thisOnInit.navigationContent = "view";
          _thisOnInit.displayNavbar();
          _thisOnInit.selectedNavbarItem = "navbar-second-toggle-view"
        }
        else if (routerEvent.urlAfterRedirects.startsWith("/dogrula") || routerEvent.urlAfterRedirects.startsWith("/d/")) {
          _thisOnInit.navigationContent = "validate";
         // _thisOnInit.displayNavbar();
          _thisOnInit.selectedNavbarItem = "navbar-second-toggle-validate"
        }
        else if (routerEvent.urlAfterRedirects.startsWith("/form-designer")) {
          _thisOnInit.navigationContent = "form-designer";
          _thisOnInit.displayNavbar();
          _thisOnInit.selectedNavbarItem = "navbar-second-toggle-prepare"
        }
        else if (routerEvent.urlAfterRedirects.startsWith("/prepare") && !routerEvent.urlAfterRedirects.startsWith("/prepare-self")) {
          _thisOnInit.navigationContent = "prepare";
          _thisOnInit.displayNavbar();
          _thisOnInit.selectedNavbarItem = "navbar-second-toggle-prepare"
        }
        else if (routerEvent.urlAfterRedirects.startsWith("/prepare-self")) {
          _thisOnInit.navigationContent = "prepare-self";
          _thisOnInit.displayNavbar();
          _thisOnInit.selectedNavbarItem = "navbar-second-toggle-prepare-self"
        }
        else if (routerEvent.urlAfterRedirects.startsWith("/template") && !routerEvent.urlAfterRedirects.startsWith("/template-self")) {
          _thisOnInit.navigationContent = "template";
          _thisOnInit.displayNavbar();
          _thisOnInit.selectedNavbarItem = "navbar-second-toggle-template"
        }
        else if (routerEvent.urlAfterRedirects.startsWith("/template-self")) {
          _thisOnInit.navigationContent = "template-self";
          _thisOnInit.displayNavbar();
          _thisOnInit.selectedNavbarItem = "navbar-second-toggle-template-self"
        }
        else if (routerEvent.urlAfterRedirects.startsWith("/multisign")) {
          _thisOnInit.navigationContent = "multisign";
          _thisOnInit.displayNavbar();
          _thisOnInit.selectedNavbarItem = "navbar-second-toggle-multisign"
        }
        else if (routerEvent.urlAfterRedirects.match("/")) {
          _thisOnInit.navigationContent = "home";
          _thisOnInit.hideNavbar();
        }
      }

    });

    this.routerParamSubscription = this.route.params.subscribe(params => {
      console.log(params);
      //this.id = +params['id']; // (+) converts string 'id' to a number
      // In a real app: dispatch action to load the details here.
    });


    //stop timer when initialize
    this.timerSubscription = interval(500).subscribe(x => {

      if (_thisOnInit.subscription === null || _thisOnInit.subscription === undefined) {
        _thisOnInit.subscription = _thisOnInit.authorization.userAccount.subscription;
      }
      else {
        //console.log("initialized...",_thisOnInit.subscription)

        if (_thisOnInit.timerSubscription != null)
          _thisOnInit.timerSubscription.unsubscribe();

        _thisOnInit.isSubscriptionInitialized = true;
        _thisOnInit.initializeMenu();
      }

    });

  }


  ngAfterViewInit(){
    this.initializeAfix();
  }


  private onToolbarEvent(event: ToolbarEvent) {
    this.currentToolbar = event;

    if(event.page == ToolbarEventPageEnum.JOB_DETAILS)
      this.page = "DETAILS";
    if(this.navigationContent == "sign" && (event.page == ToolbarEventPageEnum.JOB_SELF_SIGNING || event.page == ToolbarEventPageEnum.JOB_SIGN_REQUEST))
      this.page = "SIGN";
    if(this.navigationContent == "signcades" && (event.page == ToolbarEventPageEnum.JOB_SELF_SIGNING || event.page == ToolbarEventPageEnum.JOB_SIGN_REQUEST))
      this.page = "SIGNCADES";
    if(event.page == ToolbarEventPageEnum.JOBS)
      this.page = "JOBS";
    if(this.navigationContent == "req" && event.page == ToolbarEventPageEnum.JOB_SIGN_REQUEST)
      this.page = "REQ";
    if(this.navigationContent == "combine" && event.page == ToolbarEventPageEnum.COMBINE)
      this.page = "COMBINE";
    if(this.navigationContent == "view" && event.page == ToolbarEventPageEnum.VIEW)
      this.page = "VIEW";
    if(this.navigationContent == "validate" && event.page == ToolbarEventPageEnum.VALIDATE)
      this.page = "VALIDATE";
    if(this.navigationContent == "prepare" && event.page == ToolbarEventPageEnum.PREPARE)
      this.page = "PREPARE";
    if(this.navigationContent == "form-designer" && event.page == ToolbarEventPageEnum.DESIGN)
      this.page = "DESIGN";
    if(this.navigationContent == "prepare-self" && event.page == ToolbarEventPageEnum.PREPARE_SELF)
      this.page = "PREPARE_SELF";
    if(this.navigationContent == "doc-request" && event.page == ToolbarEventPageEnum.DOC_REQUEST)
      this.page = "DOC_REQUEST";
    if(this.navigationContent == "multisign" && event.page == ToolbarEventPageEnum.JOB_MULTISIGN_REQUEST)
      this.page = "MULTI_SIGN";
    if(this.navigationContent == "template" && event.page == ToolbarEventPageEnum.TEMPLATE_PREPARE)
      this.page = "TEMPLATE_PREPARE";
    if(this.navigationContent == "template-self" && event.page == ToolbarEventPageEnum.TEMPLATE_PREPARE_SELF)
      this.page = "TEMPLATE_PREPARE_SELF";
    if(event.location == "ARCHIVE") {
      console.log(event.location);
      this.jobJocation = "INBOX";
      this.jobLocationAction = this.translate.instant("Move to Inbox");
    }
    else if (event.location == "INBOX"){
      console.log("INBOX");
      this.jobJocation = "ARCHIVE";
      this.jobLocationAction = this.translate.instant("Archive");
    }

    console.log("recipientState " + this.currentToolbar.recipientState + " - " + this.currentToolbar.value);
    if(this.currentToolbar.recipientState == 'SIGNED' || this.currentToolbar.recipientState == 'DECLINED'){
      this.isRequestCodeUsed = true;
    }

    //trigger menu with every toolvar value change
    if(this.isSubscriptionInitialized)
       this.initializeMenu();
  }


  initializeMenu(){
    console.log("subscription status: ", this.subscription.status);

    this.subscription = this.authorization.userAccount.subscription;
    this.isMenuInitialized = true;

    //default assignment
    this.isAccountSuspended = false;
    this.isReachedMaxSignLimit = false;
    this.isRequestCodeUsed = false;
    this.isSuitToCombine = false;
    this.isSuitToCreateTemplate = false;
    this.canCreatePublicLink = false;
    this.isPlanQuotaSuitToUpload = false;

    //SELF Sign Button TEXT
    let selfSignLocal:string="";
    if(this.subscription.plan.name != "FREE" && this.currentToolbar.value=='NONE' && this.currentToolbar.jobType.toUpperCase() == 'SELF') {
      this.selfSign = '<i class="icon-pen"></i> ' + this.translate.instant("Sign Document");
      selfSignLocal = "Sign Document";
    }else if(this.currentToolbar.value=='DRAFT' && this.currentToolbar.jobType.toUpperCase() == 'SELF' ||
      this.currentToolbar.value=='IN_PROGRESS' && this.currentToolbar.jobType.toUpperCase() == 'SELF') {
      this.selfSign = '<i class="icon-pen"></i> ' + this.translate.instant("Continue Signing");
    }else if(this.subscription.plan.name == "FREE" && this.currentToolbar.value=='NONE' && this.currentToolbar.jobType.toUpperCase() == 'SELF') {
      this.selfSign = /*'<i class="icon-pen"></i> ' +*/ this.translate.instant("Sign (Basic)") + ' <b><i class="icon-info3"></i></b>';
      selfSignLocal = "Sign (Basic)";
    }
    else this.selfSign = "";


    //REQUEST Sign Button TEXT
    if(this.currentToolbar.value=='NONE' && this.currentToolbar.jobType.toUpperCase() == 'SELF' && this.subscription.plan.addRecipient == "Y") {
      this.requestSign = "Request Signature";
    }
    else if ( this.currentToolbar.value=='DRAFT' && (this.currentToolbar.jobType=='ME_OTHERS' || this.currentToolbar.jobType=='OTHERS')) {
      this.requestSign = "Continue Request";
    }
    else if(this.currentToolbar.value=='IN_PROGRESS' && this.currentToolbar.recipientState == 'WAITING' &&
      (this.currentToolbar.jobType=='ME_OTHERS' || this.currentToolbar.jobType=='OTHERS')) {
      this.requestSign = "Sign Request";
    }
    else this.requestSign = "";

    //DISABLE Sign if account suspended
    if(this.subscription.status == "SUSPENDED")
      this.isAccountSuspended = true;

    // REACH max signature limit
    if((selfSignLocal== "Sign Document" || selfSignLocal == "Sign (Basic)" ||
      this.requestSign == "Request Signature" || this.requestSign == "Request Signature" ||
      this.requestSign == "Continue Request" || this.requestSign == "Sign Request") &&
      this.subscription.monthlySignedDocuments >= (this.subscription.plan.signatureMonthly + this.subscription.extraSignature) )
    {
      this.isReachedMaxSignLimit = true;
    }

    if(this.currentToolbar.value=='NONE')
      this.isSuitToCombine = true;

    if(this.currentToolbar.value!='NONE' && this.currentToolbar.jobOwnerId==this.subscription.userId)
      this.isSuitToCreateTemplate = true;

    this.canCreatePublicLink = this.subscription.plan.publicLink == 'Y';

    if(this.subscription.plan.quota == 0){
      this.isPlanQuotaSuitToUpload = true;
    } else {
      this.isPlanQuotaSuitToUpload = this.subscription.plan.quota + this.subscription.extraStorage > this.subscription.usedStorage;
    }

    console.log("selfSignText: " + this.selfSign + " requestSignText: " + this.requestSign);
  }


  private onPaginationEvent(pageEvent: PaginationEvent) {
    this.currentPagination = pageEvent;

    //list interval title
    this.listInterval = this.currentPagination.paginationScalaTitle;

    //previous button enable-desable
    if(this.currentPagination.isPreActive)
      this.isPreButtonActive = true;
    else
      this.isPreButtonActive = false;

    //next button enable-desable
    if(this.currentPagination.isNextActive )
      this.isNextButtonActive = true;
    else
      this.isNextButtonActive = false;


    if(this.currentPagination.keywords) {
      $('#searchFilter').val('');
    }


    if(this.currentPagination.status){
      this.statusTitle("Select Status");
    }

    if(this.currentPagination.sorting != "")
    {
      if (this.currentPagination.sorting == "created") {
        this.sortingTitle("Creation Date");
        this.isSmartStatusSelected = false; //normal filter active
      } else if (this.currentPagination.sorting == "updated") {
        this.sortingTitle("Modification Date");
        this.isSmartStatusSelected = true; //smart status filter active
      }
    }

    this.selectedItem = this.currentPagination.selectedItem;
  }

  private onBulkOperationEvent(bulkOperationEvent: BulkOperationsEvent) {
    //refresh title
    if(!bulkOperationEvent.isBulkOperationActive)
      this.bulkOperationTitle("Bulk Operations");

    let self = this;
    setTimeout(function() { self.isBulkOperationActive = bulkOperationEvent.isBulkOperationActive; },0);
  }

  public bulkOperation(operation:string){
    if(operation == "BulkSign" || operation == "ApplyTemplateAndSend"){
      if(this.authorization.userAccount.subscription.plan.bulkSign == "Y"){
        this.navigationService.action(new NavigationEvent("BULK_OPERATION", operation));
      } else {
        this.notificationService.showCurrentPlanNotSuitToDo(function (isConfirmed: boolean){});
      }
    } else {
      this.navigationService.action(new NavigationEvent("BULK_OPERATION", operation));
    }
  }

  public openNewJobDialog(){
    if(this.isPlanQuotaSuitToUpload) {
      this.navigationService.action(new NavigationEvent("NEW_JOB", ""));
    } else {
      let used:number = this.subscription.usedStorage;
      let available:number = this.subscription.plan.quota + this.subscription.extraStorage;

      this.notificationService.showQuotaFull(used, available, function (isConfirmed: boolean) {
        if (isConfirmed) {
        }
      })
    }
  }

  public newJobFromTemplate(){
    this.navigationService.action(new NavigationEvent("NEW_JOB_FROM_TEMPLATE",""));
  }

  public newPublicLinkFromTemplate(){
    this.navigationService.action(new NavigationEvent("NEW_PUBLIC_LINK_FROM_TEMPLATE",""));
  }

  public openJobDetailsTagModal(){
    this.navigationService.action(new NavigationEvent("JOB_DETAILS_TAG",""));
  }

  public openJobDetailsActivityHistoryModal(){
    this.navigationService.action(new NavigationEvent("JOB_DETAILS_ACTIVITY_HISTORY",""));
  }

  public openJobDetailsInfoModal(){
    this.navigationService.action(new NavigationEvent("JOB_DETAILS_INFO",""));
  }

  public openValidationModal(){
    this.navigationService.action(new NavigationEvent("VALIDATE_DOCUMENT",""));
  }

  public shareSignedDocument(){
    this.navigationService.action(new NavigationEvent("SHARE_SIGNED_DOC",""));
  }

  public getPublicLink(){
    this.navigationService.action(new NavigationEvent("GET_PUBLIC_LINK", ""));
  }

  public stopSharingPublic(){
    this.navigationService.action(new NavigationEvent("STOP_SHARING_PUBLIC",""));
  }

  public PDFIncrementZoom(ratio: string){
    this.navigationService.action(new NavigationEvent("INCREMENT_ZOOM",ratio.toString()));
  }

  public PDFRotate(angle: number){
    this.navigationService.action(new NavigationEvent("ROTATE",angle.toString()));
  }

  public navigateToSign(){
    if(this.isReachedMaxSignLimit){
      this.notificationService.showAccountReachedMaxSignatureLimit(function(isConfirmed:boolean) {
        if(isConfirmed){ }
      });
    }else {
      this.navigationService.action(new NavigationEvent("SELF_SIGN", ""));
    }
  }

  public DeleteJob(){
    this.navigationService.action(new NavigationEvent("DELETE_DOC",""));
  }

  DownloadDocumentWithLink(){
    this.navigationService.action(new NavigationEvent("DOWNLOAD_DOC_WITH_LIK",""));
  }

  /**
   * Download the Signing Log.
   *
   * Deliberately NOT an item inside the File Operations dropdown: that dropdown is wrapped in
   * isDownloadAllowed, which is the document-download permission. Fusing the two would hide
   * the log whenever a sender has turned document download off, which is a different decision
   * about a different artifact.
   */
  DownloadSigningLog(){
    this.navigationService.action(new NavigationEvent("DOWNLOAD_SIGNING_LOG",""));
  }

  public DownloadSigned(){
    this.navigationService.action(new NavigationEvent("DOWNLOAD_SIGNED",""));
  }
  public createTemplate(){
    this.navigationService.action(new NavigationEvent("CREATE_TEMPLATE",""));
  }

  public applyTemplate(){
    this.navigationService.action(new NavigationEvent("APPLY_TEMPLATE",""));
  }

  public DownloadOriginal(){
    this.navigationService.action(new NavigationEvent("DOWNLOAD_ORJ",""));
  }

  public setJobLocation(location: string){
    this.navigationService.action(new NavigationEvent("SET_JOB_LOCATION",location));
  }

  public navigateToCombine(){
    this.navigationService.action(new NavigationEvent("COMBINE_DOC",""));
  }

  public navigateToRequest(){
    if(this.isReachedMaxSignLimit){
      this.notificationService.showAccountReachedMaxSignatureLimit(function(isConfirmed:boolean) {
        if(isConfirmed){ }
      });
    }else {
      this.navigationService.action(new NavigationEvent("REQUEST_SIGN",""));
    }
  }

  public CloseRequest(){
    this.navigationService.action(new NavigationEvent("CLOSE_REQUEST",""));
  }

  public EditRecipients(){
    this.navigationService.action(new NavigationEvent("EDIT_RECIPIENTS",""));
  }

  public SharedSigning(){
    if(this.authorization.userAccount.subscription.plan.sharedSigning == "Y"){
      this.navigationService.action(new NavigationEvent("SHARED_SIGNING",""));
    } else {
      this.notificationService.showCurrentPlanNotSuitToDo(function (isConfirmed: boolean){});
    }
  }

  public FinishSendRequest(){
    this.navigationService.action(new NavigationEvent("FINISH_SEND_REQUEST",""));
  }

  public OpenAttachments(){
    this.navigationService.action(new NavigationEvent("OPEN_ATTACHMENTS",""));
  }

  public FinishSelfSign(){
    this.navigationService.action(new NavigationEvent("FINISH_SELF_SIGN",""));
  }

  public RejectSign(){
    this.navigationService.action(new NavigationEvent("REJECT_SIGN",""));
  }

  public ApproveSign(){
    this.navigationService.action(new NavigationEvent("APPROVE_SIGN",""));
  }

  public CancelCombine(){
    this.navigationService.action(new NavigationEvent("CANCEL_COMBINE",""));
  }

  public CombineAndSave(){
    this.navigationService.action(new NavigationEvent("COMBINE_SAVE",""));
  }

  public FilterWithStatus(status: string){
    this.navigationService.action(new NavigationEvent("FILTER_WITH_STATUS", status));
  }

  public FilterWithSearch(keywords: string){
    this.lastSearchKey = keywords;
    this.navigationService.action(new NavigationEvent("FILTER_WITH_SEARCH", keywords));
  }

  public inputFocusOut(input: string){
    let thisFocusOut = this;

    setTimeout(function() {
      if(input != thisFocusOut.lastSearchKey)
        $('#searchFilter').val(thisFocusOut.lastSearchKey);
    }, 200);
  }

  public OrderBy(sorting: string){
    this.navigationService.action(new NavigationEvent("ORDER_BY", sorting));
  }

  public PreviousRecords(){
    this.navigationService.action(new NavigationEvent("PRE_RECORDS",""));
  }

  public NextRecords(){
    this.navigationService.action(new NavigationEvent("NEXT_RECORDS",""));
  }

  public statusTitle(title:string){
    this.innerHtmlStatus = this.translate.instant(title) +' <span class="caret"></span>';
  }

  public sortingTitle(title:string){
    this.innerHtmlSorting = this.translate.instant(title) +' <span class="caret"></span>';
  }

  public bulkOperationTitle(title:string){
    this.innerHtmlBulkOperations = this.translate.instant(title) +' <span class="caret"></span>';
  }

  displayNavbar(){
    if(!this.showNavbar){
      this.showNavbar = true;
      let _this = this;
      setTimeout(function() {
        _this.initializeAfix();

      }, 2000);
    }
  }

  hideNavbar(){
    this.showNavbar = false;

  }

  private initializeAfix(){
    if(this.showNavbar && !this.isAfixInitialized){
      FixedNavbar.init();
      this.isAfixInitialized = true;
    }
  }

  openSftpMenu(){
    this.navigationService.action(new NavigationEvent("SFTP_LIST",""));
  }

  ngOnDestroy(){
    this.timerSubscription.unsubscribe();
  }

}
